<div class="flex justify-content-center align-items-center h-screen">
   <div class="w-full lg:px-7 xl:w-8 xl:w-5" style="max-width: 870px;">
		<form [formGroup]="formData" (ngSubmit)="onSubmit()">
			<p-card styleClass="h-screen sm:m-8 sm:h-auto lg:m-0">
				<p-messages
					(onClose)="errorMessage.set([])"
					[styleClass]="errorMessage()?.length ? '-mt-3' : ''"
					[value]="errorMessage() ?? []" 
					[enableService]="false" 
				/>
				<div class="md:flex my-4">
					<div class="md:w-6 flex flex-column justify-content-center align-items-center px-3 gap-2">
						<img class="mb-3 md:mb-0" src="images/logo.png" width="90" alt="ep-logo">
						<p class="hidden md:block text-center font-medium">Log into your account. <br>Easy access anytime with or without app.</p>
					</div>
					<p-divider class="hidden md:block" layout="vertical" />
					<div class="md:w-6 flex flex-column gap-4 px-5">
						<h5 class="m-0 font-bold">
							<i class="pi pi-lock" style="font-size: 1rem; font-weight: bold;"></i>
							Login
						</h5>
						<div class="flex flex-column gap-1">
							<label for="countryCode">Country code</label>
							<p-dropdown 
								formControlName="countryCode" 
								[options]="countryCodes"
								optionLabel="name"
								styleClass="w-full"
								[filter]="true"
    							filterBy="name"
								(onChange)="isPhoneNumberValid.set(true)"
							>
							<ng-template pTemplate="selectedItem">
								<div class="flex align-items-center gap-2" *ngIf="countryCode">
									<img 
										[src]="'assets/flags/64x64/'+countryCode.Alpha2+'.png' | lowercase"
										style="width: 18px" />
									<div>{{ countryCode.name }}</div>
								</div>
						  </ng-template>
						  <ng-template let-countryCode pTemplate="item">
								<div class="flex align-items-center gap-2">
									<img 
										[src]="'assets/flags/64x64/'+countryCode.Alpha2+'.png' | lowercase"
										style="width: 18px" />
									<div>{{ countryCode.name }}</div>
								</div>
						  </ng-template>
							</p-dropdown>
						</div>

						<div class="flex flex-column gap-1">
							<label for="phoneNumber">Phone number</label>
							<div>
								<p-inputGroup>
									<p-inputGroupAddon>
										{{ countryCode.code }}
									</p-inputGroupAddon>
									<input
										pInputText
										formControlName="phoneNumber"
										class="w-full"
										(keydown)="inputNumberOnly($event)"
										(paste)="onPhoneNumberPaste($event)"
										(blur)="onPhoneNumberBlur()"
									/>
							  </p-inputGroup>
								
							</div>
							@if ((phoneNumber.dirty || phoneNumber.touched) && phoneNumber.errors?.['required']) {
								<small class="text-red-500">Phone number is required!</small>
							}
							@if (!isPhoneNumberValid() && phoneNumber.touched) {
								<small class="text-red-500">Phone number is invalid!</small>
							}
						</div>

						<div class="flex flex-column gap-1">
							<label for="password">Password</label>
							<p-password 
								[feedback]="false"
								[toggleMask]="true"
								formControlName="password"
								styleClass="w-full"
								[inputStyle]="{'width':'100%'}"
								name="password"
							/>
							@if ((password.dirty || password.touched) && password.errors?.['required']) {
								<small class="text-red-500">Password is required!</small>
							}
						</div>

						<a class="text-primary" routerLink="/forgot-password">Forgot password</a>
						<p-button type="submit" label="Login" styleClass="w-full" />
						
						<!-- <p-divider class="-mt-4 -mb-6"/>-->

						<!-- <div class="mt-3 w-full text-center flex align-items-center justify-content-center">
							Dont have account? <a class="text-orange-600 pl-1" routerLink="/signup">Sign up</a>
						</div>  -->
					</div>
				</div>
			</p-card>
		</form>
   </div>
</div>


